export const DATE_FORMAT_STRING = 'DD.MM.YYYY';
import { erpClient } from '@tfpl/api-client';
export const DATE_MONTH_FORMAT_STRING = 'MM. YYYY';
export const DATETIME_FORMAT_STRING = 'DD.MM.YYYY HH:mm';
export const DATE_FORMAT_STRING_MONTH = 'YYYY-MM';
export const DATE_FORMAT_STRING_DAY = 'YYYY-MM-DD';
export const DEFAULT_TABLE_DEBOUNCE_TIME = 1000;
export const VALIDATION_ERROR_CODE = 409;
export const DATA_CONFLICT_ERROR = 'Conflict';
export const EMAIL_IS_ALREADY_TAKEN_ERROR = 'EMAIL_IS_ALREADY_TAKEN';
export const PHONE_IS_ALREADY_TAKEN_ERROR = 'PHONE_IS_ALREADY_TAKEN';
export const INPUT_VALIDATION_ERROR = 'INPUT_VALIDATION_ERROR';
export const TFPL_ID_TOKEN = 'tfpl-id-token';
export const DEFAULT_DIALOG_WIDTH = 1000;
export const LEFT_MENU_RAIL_WIDTH = 65;
export const AG_GRID_CELL_MIN_SMALL_WIDTH = 90;
export const AG_GRID_CELL_MIN_WIDTH = 150;
export const AG_GRID_TEXT_CELL_MIN_WIDTH = 175;
export const FORBIDDEN_ERROR_CODE = 403;
export const DEFAULT_QUICK_SEARCH_DEBOUNCE_TIME = 200;
export const INTERNAL_COLLABORATOR = 'INTERNAL_EMPLOYEE' as erpClient.CollaboratorOutputDto['type'];
export const EXTERNAL_COLLABORATOR = 'EXTERNAL_EMPLOYEE' as erpClient.CollaboratorOutputDto['type'];
export const LEAVING_CHECKLIST_EXTERNAL = 'EXTERNAL';
export const LEAVING_CHECKLIST_INTERNAL = 'INTERNAL';
export const BAD_REQUEST = 400;
export const NO_UNIQUE_ORGANIZATION_POSITIONS = 'NO_UNIQUE_ORGANIZATION_POSITIONS';
export const HPP = 'HPP';
export const DPP = 'DPP';
export const ZL = 'ŽL';
export const MAX_DPP_WAGE_WITHOUT_VAT = 10000;
export const GROSS_WAGE_VAT = 1.35;
export const WORKING_DAYS_COUNT = 252;
export const MAX_HPP_WORKLOAD_HOURS = 168;
export const MAX_ZL_WORKLOAD_HOURS = 168;
export const MAX_DPP_WORKLOAD_HOURS = 28;
export const MAX_FULL_TIME_EQUIVALENT = 2;

export const INVOICE_STATUS_PAID = 'PAID';
export const INVOICE_STATUS_CURRENT = 'CURRENT';
export const INVOICE_STATUS_PAST_DUE = 'PAST_DUE';
